export default __webpack_public_path__ + "static/media/bgg.5586a8b6.jpg";